import { useEffect } from 'react';
import { Grid, Typography, TextField } from '@mui/material';
import Paper from '../../../components/Paper';
import LogicalChooser from '../../../components/LogicalChooserV0';
import { nextStepValidtor, writeProductDetailSummary } from '../../../utils/utils';
import styles from './productDetails.module.scss'
import { showNudge, SEVEARITY_CONTS } from '../../../components/Nudge/nudgeReducer';
import { useDispatch, useSelector } from 'react-redux';
import { isValidForNext, resetStep3MissingValue } from '../createCampaignReducer';

const optionHeader = "Product Attributes"

const ProductDetails = ({ data, state, setters, handlers, validation, validationSetters }) => {
  const dispatch  = useDispatch()
  const {isRemovedValue, message} = useSelector(store => store.createCampaign.step3MissingValue)

  // if value are missing, nudge will be shown
  useEffect(()=>{
    isRemovedValue && dispatch(showNudge({ message, type: SEVEARITY_CONTS.error }))
    // clear the redux storage( createCampaign ) for missing value while unmounting
    return () => {
      dispatch(resetStep3MissingValue())
    }
  },[])

  // logic to enable and disable next button
  useEffect(() => {
    const isNextEnabled = state.attributes.reduce(nextStepValidtor,true)
    dispatch(isValidForNext(isNextEnabled))
  },[state])

  return (
    <Paper heading="Step 3 -  Fill Product Details">
      <Grid container className={styles.productDetailsContainer} justifyContent="space-between" alignItems="baseline">
        <Grid container item xs={12}>
          <Typography className={styles.heading}>Select Products <span className={styles.imp}>*</span></Typography>
        </Grid>
        <Grid item xs={12}>
          <LogicalChooser data={data} handlers={handlers} optionHeader={optionHeader} parentState={state} updateParentState={setters} isOptionValid={validation} isOptionValidSetters={validationSetters} />
        </Grid>
        <Grid container className={styles.summaryContainer} item xs={12} sx={{ m: "32px 0px 15px"}}>
          <Grid item xs={12}>
            <Typography className={styles.summaryHeading}>Products Summary</Typography>
          </Grid>
          <Grid container item xs={12} className={styles.summary} justifyContent="space-between">
            <Grid container item xs={8}>
              <Grid item xs={12} whiteSpace="normal">
                {writeProductDetailSummary(state)}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ProductDetails
